export default __webpack_public_path__ + "static/file_example_png_3mb-02ba56f4690e3ad560c2dc86b7a58e2d.png";